// IMPORTS
// Modules
import { Routes, Route, Link } from 'react-router-dom';
import { useState } from 'react';
// Components
import { OHSCookiesGet, OHSCookiesSet } from './onehivesystems/js/OHSCookies';
import OHSLoading from './onehivesystems/js/OHSLoading';
import OHSPopup from './onehivesystems/js/OHSPopup';
import OHSConfirmation from './onehivesystems/js/OHSConfirmation';
import GlobalDashboard from './routes/GlobalDashboard/GlobalDashboard';
import Settings from './routes/Settings/Settings';
import ApplicationSettings from './routes/ApplicationSettings/ApplicationSettings';
import UserAccounts from './routes/UserAccounts/UserAccounts';
import AuditLogs from './routes/AuditLogs/AuditLogs';
import BackupRestore from './routes/BackupRestore/BackupRestore';
import Profile from './routes/Profile/Profile';
import Login from './routes/Login/Login';
import OnePort from './components/oneport/OnePort';
import OnePortDashboard from './components/oneport/routes/Dashboard/Dashboard';
import OnePortLocations from './components/oneport/routes/Locations/Locations';
import OnePortCollections from './components/oneport/routes/Collections/Collections';
import OnePortDevices from './components/oneport/routes/Devices/Devices';
import OnePortFields from './components/oneport/routes/Fields/Fields';
import OnePortCommands from './components/oneport/routes/Commands/Commands';
import OnePortPortTemplates from './components/oneport/routes/PortTemplates/PortTemplates';
import OnePortDevice from './components/oneport/routes/Device/Device';
import OnePortPortTopology from './components/oneport/routes/PortTopology/PortTopology';
import OnePortCustomQuery from './components/oneport/routes/CustomQuery/CustomQuery';
import OnePortPortCompare from './components/oneport/routes/PortCompare/PortCompare';
import OnePortBulkActions from './components/oneport/routes/BulkActions/BulkActions';
// Assets
import './OneHive.scss';
import icon_grid_light from './onehivesystems/icons/grid_light.svg';
import icon_grid_dark from './onehivesystems/icons/grid_dark.svg';
import icon_search_light from './onehivesystems/icons/search_light.svg';
import icon_search_dark from './onehivesystems/icons/search_dark.svg';
import icon_gear_light from './onehivesystems/icons/gear_light.svg';
import icon_gear_dark from './onehivesystems/icons/gear_dark.svg';
import icon_user_light from './onehivesystems/icons/user_light.svg';
import icon_user_dark from './onehivesystems/icons/user_dark.svg';
import icon_sun_light from './onehivesystems/icons/sun_light.svg';
import icon_moon_dark from './onehivesystems/icons/moon_dark.svg';
import logo_icon from './onehivesystems/logos/ohs_logo_icon_gradient1.svg';


// COMPONENT
export default function OneHive () {
   // States and Variables
   const [loading, setLoading] = useState(false);
   const [popup, setPopup] = useState({
      display: false,
      title: null,
      message: null,
      severity: null,
      timespan: null
   });
   const [confirmation, setConfirmation] = useState({
      display: false,
      message: null,
      proceed: null,
      yesno: false
   });
   const themes = {
      light: "light",
      dark: "dark"
   };
   const [theme, setTheme] = useState(OHSCookiesGet('ohs_theme') ? OHSCookiesGet('ohs_theme') : themes.light);
   const [oneHiveTitle, setOneHiveTitle] = useState("Your OneHive");
   const [oneHiveNav, setOneHiveNav] = useState(false);
   const [oneHiveSearch, setOneHiveSearch] = useState(false);
   const [appWideContent, setAppWideContent] = useState(null); // custom variables and functions that an app uses within itself
   const routeProps = {
      setLoading: setLoading,
      setPopup: setPopup,
      setConfirmation: setConfirmation,
      themes: themes,
      theme: theme,
      setOneHiveTitle: setOneHiveTitle,
      setOneHiveNav: setOneHiveNav,
      setOneHiveSearch: setOneHiveSearch,
      appWideContent: appWideContent,
      setAppWideContent, setAppWideContent
   };

   // Authentication
   if (!OHSCookiesGet('ohs_auth_token')) {
      return (
         <Login />
      );
   }

   // Functions
   const toggleTheme = function () {
      if (theme === themes.light) {
         setTheme(themes.dark);
         OHSCookiesSet('ohs_theme', themes.dark);
      } else if (theme === themes.dark) {
         setTheme(themes.light);
         OHSCookiesSet('ohs_theme', themes.light);
      }
   }
   const toggleOneHiveNav = function () {
      setOneHiveNav(!oneHiveNav);
   }
   const toggleOneHiveSearch = function () {
      setOneHiveSearch(!oneHiveSearch);
   }

   // Component
   return (
      <div className={`onehive onehive-theme-${theme}`}>
         <OHSLoading toggle={loading} />
         <OHSPopup popup={popup} setPopup={setPopup} />
         <OHSConfirmation confirmation={confirmation} setConfirmation={setConfirmation} />
         {window.location.pathname !== "/login" && <div className="onehive-header">
            <div className="onehive-header-left">
               <div className="onehive-header-logo">
                  <Link to='/'><img src={logo_icon} alt="OHS Logo Icon" /></Link>
               </div>
               <div className="onehive-header-title">
                  <p>{oneHiveTitle}</p>
               </div>
            </div>
            <div className="onehive-header-right">
               <div className="onehive-header-theme" onClick={toggleTheme}>
                  <img src={theme === themes.light ? icon_moon_dark : icon_sun_light} alt="Theme Icon" />
               </div>
               <div className="onehive-header-apps" onClick={toggleOneHiveNav}>
                  <img src={theme === themes.light ? icon_grid_dark : icon_grid_light} alt="Grid Icon" />
               </div>
               <div className="onehive-header-search" onClick={toggleOneHiveSearch}>
                  <img src={theme === themes.light ? icon_search_dark : icon_search_light} alt="Search Icon" />
               </div>
               <div className="onehive-header-settings">
                  <Link to='/settings'>
                     <img src={theme === themes.light ? icon_gear_dark : icon_gear_light} alt="Gear Icon" />
                  </Link>
               </div>
               <div className="onehive-header-user">
                  <Link to='/profile'>
                     <img src={theme === themes.light ? icon_user_dark : icon_user_light} alt="User Icon" />
                  </Link>
               </div>
            </div>
         </div>}
         {oneHiveNav && <div className="onehive-nav">
            <Link to='/oneacl'>OneACL</Link>
            <Link to='/oneport'>OnePort</Link>
         </div>}
         {oneHiveSearch && <div className="onehive-search">
            <p>Search Results</p>
         </div>}
         <div className="onehive-app">
            <Routes>
               <Route exact path='/' element={<GlobalDashboard onehive={routeProps} />} />
               <Route exact path='/login' element={<Login />} />
               <Route element={<Settings onehive={routeProps} />}>
                  <Route exact path='/profile' element={<Profile onehive={routeProps} />} />
                  <Route exact path='/settings' element={<ApplicationSettings onehive={routeProps} />} />
                  <Route exact path='/useraccounts' element={<UserAccounts onehive={routeProps} />} />
                  <Route exact path='/auditlogs' element={<AuditLogs onehive={routeProps} />} />
                  <Route exact path='/backuprestore' element={<BackupRestore onehive={routeProps} />} />
               </Route>
               <Route element={<OnePort onehive={routeProps} />}>
                  <Route exact path='/oneport' element={<OnePortDashboard onehive={routeProps} />} />
                  <Route exact path='/oneport/locations' element={<OnePortLocations onehive={routeProps} />} />
                  <Route exact path='/oneport/collections' element={<OnePortCollections onehive={routeProps} />} />
                  <Route exact path='/oneport/devices' element={<OnePortDevices onehive={routeProps} />} />
                  <Route exact path='/oneport/fields' element={<OnePortFields onehive={routeProps} />} />
                  <Route exact path='/oneport/commands' element={<OnePortCommands onehive={routeProps} />} />
                  <Route exact path='/oneport/porttemplates' element={<OnePortPortTemplates onehive={routeProps} />} />
                  <Route exact path='/oneport/device' element={<OnePortDevice onehive={routeProps} />} />
                  <Route exact path='/oneport/porttopology' element={<OnePortPortTopology onehive={routeProps} />} />
                  <Route exact path='/oneport/customquery' element={<OnePortCustomQuery onehive={routeProps} />} />
                  <Route exact path='/oneport/portcompare' element={<OnePortPortCompare onehive={routeProps} />} />
                  <Route exact path='/oneport/bulkactions' element={<OnePortBulkActions onehive={routeProps} />} />
               </Route>
            </Routes>
         </div>
      </div>
   );
};